import React from 'react'; // Removed useState
import { MapPin, Clock, Phone, Mail } from 'lucide-react'; // Removed Send, Loader

//  UPDATED Shop details object (with Sardar Jewellers info)
const SHOP_DETAILS = {
  name: "Sardar Jewellers",
  tagline: "Your destination for timeless elegance and pure gold.",
    addressLine1: "Sardar Jewellers, purana shivli road, near balaji shadi cards", 
  addressLine2: " Kalayanpur, Kanpur, Uttar Pradesh 208016", 
  phone: "+91 8441856072",
  email: "ashutoshrajput203@gmail.com",
  timings: "Monday - Saturday: 10:30 AM - 8:30 PM | Sunday: Closed",
  
 
  mapEmbedUrl: "https://maps.google.com/maps?q=Sardar%20Jewellers%20Kalyanpur%20Kanpur%20Dehat&t=&z=15&ie=UTF8&iwloc=&output=embed", 
};

// Interface for form data is no longer needed

const VisitShopPage: React.FC = () => {
  

  return (
    <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      
      {/* Page Title */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-extrabold text-amber-900 font-[Cinzel] mb-2">
          Visit Our Showroom: {SHOP_DETAILS.name}
        </h1>
        <p className="text-lg text-gray-600">
          {SHOP_DETAILS.tagline}
        </p>
      </div>

      {/* Main Content: Details + Map */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
        
        {/* Shop Details (No Change, using updated info) */}
        <div className="p-6 bg-amber-50 rounded-lg shadow-lg border border-amber-200">
          <h2 className="text-3xl font-bold text-amber-800 mb-6 border-b pb-3">
            {SHOP_DETAILS.name}
          </h2>
          <div className="space-y-4 text-gray-700">
            <div className="flex items-start">
              <MapPin className="text-amber-700 mr-3 mt-1 flex-shrink-0" size={20} />
              <div>
                <p className="font-semibold">Address</p>
                <p>{SHOP_DETAILS.addressLine1}</p>
                <p>{SHOP_DETAILS.addressLine2}</p>
              </div>
            </div>
            <div className="flex items-start">
              <Clock className="text-amber-700 mr-3 mt-1 flex-shrink-0" size={20} />
              <div>
                <p className="font-semibold">Opening Hours</p>
                <p>{SHOP_DETAILS.timings}</p>
              </div>
            </div>
            <div className="flex items-center">
              <Phone className="text-amber-700 mr-3 flex-shrink-0" size={20} />
              <p className="font-semibold">Call Us: <a href={`tel:${SHOP_DETAILS.phone}`} className="text-blue-600 hover:text-blue-800">{SHOP_DETAILS.phone}</a></p>
            </div>
            <div className="flex items-center">
              <Mail className="text-amber-700 mr-3 flex-shrink-0" size={20} />
              <p className="font-semibold">Email: <a href={`mailto:${SHOP_DETAILS.email}`} className="text-blue-600 hover:text-blue-800">{SHOP_DETAILS.email}</a></p>
            </div>
          </div>
        </div>

        {/* Google Map (using new address URL) */}
        <div className="rounded-lg shadow-xl overflow-hidden h-96 lg:h-auto">
          <iframe
            src={SHOP_DETAILS.mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={true} // Changed to true for better map experience
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Sardar Jewellers Location Map"
          ></iframe>
        </div>
      </div>
      
      
      
    </div>
  );
};

export default VisitShopPage;